import React, { useMemo } from "react";

import Box from "@mui/material/Box";

import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import { ButtonVariant } from "../../../Constant/button";
import Styled from "./StandartButton.styled";

const MUI_VARIANTS = ["text", "outlined", "contained"];

/**
 * @param {object} props
 * @param {JSX.Element} [props.value]
 * @param {string} [props.to]
 * @param {Function} [props.onClick]
 * @param {any} [props.variant]
 * @param {JSX.Element} [props.children]
 * @param {boolean} [props.iconButton]
 * @param {boolean} [props.rounded]
 * @param {boolean} [props.isLoading]
 * @param {object} [props.wrapperSx]
 * @param {import('react').Ref} [props.setRef]
 * @returns {JSX.Element}
 */
const StandartButton = ({
    value,
    to,
    onClick,
    variant,
    children,
    iconButton,
    noBorder,
    rounded,
    setRef,
    className,
    isLoading,
    wrapperSx,
    ...buttonProps
}: any) => {
    const muiButtonColor = useMemo(() => {
        const handlers = [
            {
                predicate: () => variant === ButtonVariant.BLACK_OUTLINED,
                handler: () => undefined,
            },
            {
                predicate: () => variant === ButtonVariant.BLACK_OUTLINED,
                handler: () => "primary",
            },
            {
                predicate: () => variant === ButtonVariant.DANGER_OUTLINED,
                handler: () => "primary",
            },
        ];

        return handlers?.find(({ predicate }) => predicate)?.handler();
    }, []);

    const isMuiVariant = MUI_VARIANTS.includes(variant);

    const button = (
        <Styled.StandartButton
            ref={setRef}
            {...(to ? { component: Link, to } : {})}
            onClick={onClick}
            color={muiButtonColor}
            {...(isMuiVariant ? { variant } : {})}
            {...buttonProps}
            className={`${!isMuiVariant ? variant || "" : ""} ${
                noBorder ? "no-border" : ""
            } ${rounded ? "rounded" : ""} ${iconButton ? "icon-button" : ""} ${
                className || ""
            }`}
        >
            {value || children}
        </Styled.StandartButton>
    );

    if (isLoading === undefined) {
        return button;
    }

    return (
        <Box position="relative" height={"fit-content"} sx={wrapperSx}>
            {isLoading && (
                <div className="circle-loader">
                    <ClipLoader color="#000" size={18} />
                </div>
            )}
            {button}
        </Box>
    );
};

export default StandartButton;
